import React, { useCallback } from 'react'

import { useQueryClient } from '@tanstack/react-query'
import { Card, Skeleton } from 'antd'

import { useGetAIChatSessionQuery } from 'src/fetch/aiChatSessions'
import AISessionDisplay from 'src/pages/AIAssistantHistoryPage/AISessionDisplay'
import { QueryKey } from 'src/utils/queryClient'

type Props = {
  aiChatSessionId: number | null
}

const ViewAIChatSession = ({ aiChatSessionId }: Props) => {
  const {
    session,
    isFetching,
    refetch: refetchSession,
  } = useGetAIChatSessionQuery({
    variables: { id: aiChatSessionId ?? -1 },
    enabled: aiChatSessionId !== null,
  })

  const queryClient = useQueryClient()
  const refetch = useCallback(async () => {
    await refetchSession()
    await queryClient.invalidateQueries({ queryKey: [QueryKey.AIChatSessionOverview] })
  }, [refetchSession, queryClient])

  return (
    <Card
      style={{ height: '100%', display: 'flex', flexDirection: 'column' }}
      bodyStyle={{
        flex: 1,
        overflow: 'auto',
        padding: '16px',
      }}
    >
      {isFetching && <Skeleton active />}
      {!isFetching && session && <AISessionDisplay session={session} refetch={refetch} />}
    </Card>
  )
}

export default React.memo(ViewAIChatSession)
